<template>
  <div class="mycontent">
    <van-collapse v-model="activeNames">
      <!-- <van-collapse-item title="登记证信息" name="1">内容</van-collapse-item> -->
      <!-- <van-collapse-item title="登记证信息" value="1243" name="1" icon="shop-o"> -->
      <van-collapse-item
        title="登记证信息"
        name="1"
        icon="shop-o"
        v-if="
          !dataRes.registNo || !dataRes.registNo.startsWith('PD222288')
        "
      >
        <ul class="list-group">
          <li class="list-group-item">
            <span>农药产品名称：</span
            ><span id="registName">{{ (dataRes.totalContent || '') + (dataRes.registName || '') + (dataRes.shape || '') }}</span>
          </li>
          <li class="list-group-item">
            <span>农药登记证号：</span
            ><span id="registNo">{{ dataRes.registNo }}</span>
          </li>
          <li class="list-group-item">
            <span>登记证持有人：</span
            ><span id="registCompany">{{ dataRes.registCompany }}</span>
          </li>
          <li class="list-group-item">
            <span>编码：</span><span id="code">{{ dataRes.code }}</span> 
          </li>
          <li class="list-group-item">
            <span>追溯网址：</span>
            <a id="traceUrl" :href="dataRes.traceUrl">{{ dataRes.traceUrl }}</a>
          </li>
        </ul>
      </van-collapse-item>
      <!-- <van-collapse-item title="商标规格信息" name="2">内容</van-collapse-item> -->
      <van-collapse-item name="2">
        <template #title>
          <div><van-icon name="hot-o" />商标规格信息</div>
        </template>
        <ul class="list-group">
          <li class="list-group-item">
            <span>规格名称：</span
            ><span id="specName">{{ dataRes.specName }}</span>
          </li>
          <li class="list-group-item">
            <span>商标名称：</span
            ><span id="tagname">{{ dataRes.tagSubName }}</span>
          </li>
        </ul>
      </van-collapse-item>
      <van-collapse-item title="生产质检信息" name="3" icon="font-o">
        <ul class="list-group">
          <li class="list-group-item">
            <span>生产批次：</span
            ><span id="batchNo">{{ batchVisible && dataRes.batchNo ? dataRes.batchNo : '见喷码或合格证' }}</span>
          </li>
          <li class="list-group-item">
            <span>生产日期：</span
            ><span id="produceDate">{{ formatBatchDate(dataRes.batchDate) }}</span>
          </li>
          <!-- <li class="list-group-item"><span>有效期至：</span><span id="failDate">{{dataRes.failDate}}</span></li> -->
          <li class="list-group-item">
            <span>质检员：</span
            ><span id="checkPeople">01</span>
          </li>
          <!-- <li class="list-group-item"><span>质检日期：</span><span id="checkDate"></span></li> -->
          <li class="list-group-item">
            <span>质检结果：</span
            ><span id="checkResult">{{ dataRes.checkResult }}</span>
          </li>
          <li class="list-group-item">
            <span>货源归属：</span><span id="owner">{{ dataRes.owner }}</span>
          </li>
          <li class="list-group-item" v-if="dataRes.ownerLine != undefined">
            <span>终端归属：</span
            ><span id="ownerLine">{{ dataRes.ownerLine }}</span>
          </li>
        </ul>
      </van-collapse-item>
      <van-collapse-item title="原药信息" name="4" icon="star-o" v-if="is2026Batch && materialComponents.length > 0">
        <div v-for="(component, componentIndex) in materialComponents" :key="componentIndex" class="component-wrapper">
          <ul class="list-group">
            <li class="list-group-item component-title">
              <span>{{ component.partName }}</span>
            </li>
            <div v-for="(manufacturer, manuIndex) in component.manufacturerList" :key="manuIndex" class="manufacturer-item">
              <li class="list-group-item">
                <span v-if="!isMaterialInfoData">厂家名称：</span>
                <span v-else>厂家名称：</span>
                <span v-if="manufacturer.manufacturerName === '查询中'" class="loading-circle"></span>
                <span v-else>{{ manufacturer.manufacturerName }}</span>
              </li>
              <li class="list-group-item">
                <span>登记证号：</span>
                <span v-if="manufacturer.manufacturerRegNo === '查询中'" class="loading-circle"></span>
                <span v-else>{{ manufacturer.manufacturerRegNo }}</span>
              </li>
            </div>
          </ul>
        </div>
      </van-collapse-item>
      <van-collapse-item title="查询信息" name="5" icon="eye-o">
        <ul class="list-group">
          <li class="list-group-item">
            <span>累计查询次数：</span
            ><span id="count">{{ dataRes.count }}</span>
          </li>
          <li class="list-group-item">
            <span>上次查询时间：</span
            ><span id="time">{{ dataRes.lastTime }}</span>
          </li>
        </ul>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { parseTime } from '@/utils/ruoyi'

export default {
  name: 'MyContent',
  props: {
    dataRes: Object
  },
  data () {
    return {
      showItem: true,
      activeNames: ['1', '2', '3', '4'],
      materialComponents: [],
      isMaterialInfoData: false // 标志位，区分数据来源
    }
  },
  // 进入加入背景颜色
  mounted () {
    this.showLog()
    console.log(this.dataRes)
    this.parseMaterialInfo()
  },
  watch: {
    dataRes: {
      handler(newVal) {
        this.parseMaterialInfo()
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    // 是否允许显示批次号和生产日期：生产日期在 2026-11-01（含）之后才显示
    batchVisible () {
      const val = this.dataRes.batchDate
      if (!val) {
        return false
      }
      let timestamp = val
      if (typeof val === 'string' && /^[0-9]+$/.test(val)) {
        timestamp = parseInt(val)
      }
      // 兼容秒级时间戳
      if (typeof timestamp === 'number' && timestamp.toString().length === 10) {
        timestamp *= 1000
      }
      const date = new Date(timestamp)
      if (isNaN(date.getTime())) {
        return false
      }
      // 2026-11-01 00:00:00（本地时区）
      return timestamp >= new Date(2026, 10, 1).getTime()
    },
    is2026Batch () {
      // showStatus=1 时不显示原药信息
      if (this.dataRes.showStatus === 1) {
        return false
      }

      // 优先使用materialInfo
      if (this.dataRes.materialInfo && this.dataRes.materialInfo.trim() !== '') {
        return true
      }

      // 如果materialInfo没有数据，再使用materialInfoData
      if (this.dataRes.materialInfoData && this.dataRes.materialInfoData.trim() !== '') {
        return true
      }

      // 如果materialInfoData和materialInfo都为空，则不显示原药信息
      if (
        (!this.dataRes.materialInfoData || this.dataRes.materialInfoData.trim() === '') &&
        (!this.dataRes.materialInfo || this.dataRes.materialInfo.trim() === '')
      ) {
        return false
      }
      
      // 如果productionDate和materialInfo都为空，则不显示原药信息
      if (!this.dataRes.productionDate && !this.dataRes.materialInfo) {
        return false
      }
      
      if (!this.dataRes.productionDate) {
        return false
      }
      
      try {
        const timestamp = parseInt(this.dataRes.productionDate)
        if (isNaN(timestamp)) {
          return false
        }
        const date = new Date(timestamp)
        return date.getFullYear() === 2026
      } catch (error) {
        console.error('解析生产日期失败:', error)
        return false
      }
    }
  },
  methods: {
    // 格式化生产日期：2026-11-01（含）之后才显示，时间戳（秒或毫秒）转 yyyy-MM-dd，无值或非法时显示兜底文案
    formatBatchDate (val) {
      if (!this.batchVisible) {
        return '见喷码或合格证'
      }
      const dateText = parseTime(val, '{y}-{m}-{d}')
      if (!dateText || dateText.includes('NaN')) {
        return '见喷码或合格证'
      }
      return dateText
    },
    showLog () {
      // console.log(111,this.dataRes);
      console.log(112, this.dataRes.ownerLine)
    },
    parseMaterialInfo () {
      try {
        let components = []
        let isData = false

        // 优先使用materialInfo
        if (this.dataRes.materialInfo && this.dataRes.materialInfo.trim() !== '') {
          const materialData = JSON.parse(this.dataRes.materialInfo)
          if (materialData && materialData.matRegGroupVOList && Array.isArray(materialData.matRegGroupVOList) && materialData.matRegGroupVOList.length > 0) {
            components = materialData.matRegGroupVOList.map(item => ({
              partName: (item.partName || '').trim(),
              manufacturerList: (item.manufacturerList || []).map(manu => ({
                manufacturerName: (manu.manufacturerName || '').trim(),
                manufacturerRegNo: (manu.manufacturerRegNo || '').trim()
              }))
            }))
            isData = false
          } else if (this.dataRes.materialInfoData && this.dataRes.materialInfoData.trim() !== '') {
            // 如果materialInfo的matRegGroupVOList为空，再使用materialInfoData
            const materialData2 = JSON.parse(this.dataRes.materialInfoData)
            if (materialData2 && Array.isArray(materialData2)) {
              components = materialData2.map(item => ({
                partName: (item.name || '').trim(),
                manufacturerList: [{
                  manufacturerName: (item.company || '').trim(),
                  manufacturerRegNo: (item.registNo || '').trim()
                }]
              }))
              isData = true
            }
          }
        } else if (this.dataRes.materialInfoData && this.dataRes.materialInfoData.trim() !== '') {
          // 如果materialInfo为空，使用materialInfoData
          const materialData = JSON.parse(this.dataRes.materialInfoData)
          if (materialData && Array.isArray(materialData)) {
            components = materialData.map(item => ({
              partName: (item.name || '').trim(),
              manufacturerList: [{
                manufacturerName: (item.company || '').trim(),
                manufacturerRegNo: (item.registNo || '').trim()
              }]
            }))
            isData = true
          }
        }

        // 去重：根据原药名称、公司名称、登记证号都相同的情况下只保留一个
        const uniqueComponents = []
        const seen = new Set()
        components.forEach(component => {
          if (component.manufacturerList && component.manufacturerList.length > 0) {
            const manufacturer = component.manufacturerList[0]
            const key = `${(component.partName || '').trim()}-${(manufacturer.manufacturerName || '').trim()}-${(manufacturer.manufacturerRegNo || '').trim()}`
            if (!seen.has(key)) {
              seen.add(key)
              uniqueComponents.push(component)
            }
          }
        })

        this.materialComponents = uniqueComponents
        this.isMaterialInfoData = isData
      } catch (error) {
        console.error('解析原药信息失败:', error)
        this.materialComponents = []
        this.isMaterialInfoData = false
      }
    },
    getComponentLabel (index) {
      const labels = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J']
      return labels[index] || String.fromCharCode(65 + index)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.component-wrapper {
  margin-bottom: 16px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.component-title {
  font-weight: bold;
  font-size: 16px;
  background-color: #e8f5e9;
  border-radius: 4px;
  padding: 8px;
  color: #2a792f;
  margin-bottom: 10px;
}

.manufacturer-item {
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 8px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.no-data {
  text-align: center;
  padding: 16px;
  color: #999;
}

.list-group-item {
  display: flex;
  align-items: center;
}

.loading-circle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #e5eaf3;
  border-top-color: #1989fa;
  animation: loading-spin 0.8s linear infinite;
}

@keyframes loading-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
